import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, MasterPages, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions, getPermissions } from "../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const RoleList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add,edit,remove, view} =AllPermissions.getRolePermission;
  const navigate = useNavigate();
  const [roleListData, setRoleListData] = useState<any>([])
  const isMobile = IsSmallScreen();
  const [totalCount, setTotalCount] = useState<any>(0);
  useEffect(() => {
            updateMainHeader("Roles");
            breadCrumbsStore.updateBreadCrumbs([
                { "Roles": "" },
              
            ]);
        });
  useEffect(() => {
    const getRoles = async () => {
      try {
        const response: any = await callAPI('user-roles/all', Method.GET, null, null);
        setRoleListData(response || []);
        setTotalCount(response?.length || 0)
      }
      catch (e) {
      }
    }
    getRoles();
  }, [])
  /**
   * Edit function
   * @param action 
   * @param row 
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/role/edit/${row?.id}`)
    }

  };
  const columns: IColumns[] = [

    {
      header: "Role Name",
      fieldName: "roleName",
      type: "default",
      //  sortable: true
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),
    },

  ];
  const mobColumns: IOrderColumns[] = [

    {
      header: "Role Name",
      fieldName: "roleName",
      type: "default",
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },

  ];
  const handleClick = () => {
    navigate('/role/create')
  }
  return (
    <>
      <Grid container spacing={2}>
        {view ? <Grid item xs={12}>
          {!isMobile && <WSDataGrid
            id="roleListGrid"
            title="Roles"
            columns={columns}
            data={roleListData}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleClick}
            gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
          />
          }
          {isMobile &&
            <WSMobileDataGridAdvanced title={'Roles'} addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleClick} columns={mobColumns} id="roleListGrid" data={roleListData} />
          }
        </Grid>
          : <PermissionDenied />}
      </Grid>
    </>
  )
})